export default "__VITE_ASSET__Ca85bLYn__"